import React, { Component } from 'react';
import './PersonsScreen.css';
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import { getAge, parseDate } from '../../../utils/parser';
import { I18n } from 'react-redux-i18n';
import Button from '../../../components/common/Button';
import Input from '../../../components/common/Input';
import FilterModal from '../FilterModal';
import SquareButton from '../../../components/common/SquareButton';
import { notify } from 'react-notify-toast';
import Dropdown from '../../../components/common/Dropdown/Dropdown';
import Loader from '../../../components/common/Loader';
import TablePaginationDrawer from '../../../components/common/TablePaginationDrawer/TablePaginationDrawer';
import EmailReportConfirmModal from '../EmailReportConfirmModal/EmailReportConfirmModal';
import { success as successUI, error as errorUI } from '../../../utils/modals';
import TableLoader from '../../../components/common/TableLoader/TableLoader';
import { Tabs, Tab } from 'react-bootstrap';
import {
  SnackBar,
  successMessage,
  errorMessage,
} from '../../../utils/snackbar';
import ReactFileReader from 'react-file-reader';
import DateRangePickerFilter from '../../../components/common/DateRangePickerFilter/DateRangePickerFilter';
import FormDropdown from '../../../components/common/Dropdown/FormDropdown';
import DownloadReportModal from '../../../components/common/DownloadReportModal/DownloadReportModal';
import SearchInput from '../../../components/common/SearchInput/SearchInput';

import dayjs from 'dayjs';
import ModalShare from '../ModalShare';
import TableMenuItem from '../../../components/common/TableMenuItem/TableMenuItem';
import LargeTextTooltip from '../../../components/common/LargeTextTooltip';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Tooltip } from 'react-tooltip';
import { servicesReports } from '../PersonDetailScreen/services/reports.service';
import {
  hasINESCampaigns,
  isINESAccount,
  isINESBranch,
  INES_BRANCHES,
} from '../../../utils/inesValidator';
import { persistGroupTrendsSelection } from '../GroupTrends/groupTrendsSelection';

dayjs.extend(customParseFormat);

/**
 * Note 1: componentDidUpdate state.fetch logic changed
 * 		because now the input can only be accessed while
 * 		request status is 'success'.
 */

/**
 * Helper function to determine the branch parameter value for INES requests
 * @param {Object} user - User object containing branch and account information
 * @returns {string|null} Branch parameter value or null if not applicable
 */
const getINESBranchParameter = (user) => {
  // If account name is "Educación El Salvador", don't send branch parameter
  if (isINESAccount(user?.account)) {
    return null;
  }

  // Check branch name and return corresponding parameter value
  const branchName = user?.branch?.name;
  if (branchName === INES_BRANCHES.BACHILLERATO) {
    return 'bachillerato';
  }
  if (branchName === INES_BRANCHES.TECNICO_UNIVERSITARIO) {
    return 'tecnico';
  }

  return null;
};

const initialValues = {
  profiles: { inputValue: [] },
  genders: { inputValue: [] },
  partners: { inputValue: [] },
  age: { inputValue: '' },
  emotionalIntelligence: { inputValue: [] },
  campaigns: { inputValue: [] },
  code: { inputValue: '' },
  search: { inputValue: '' },
  institution: { inputValue: '' },
  institutionDropdown: { inputValue: null },
};

class PersonsScreen extends Component {
  state = {
    showFilter: false,
    values: {
      ...initialValues,
      search: this.props.savedSearchInput || { inputValue: '' },
      //savedCustomFIlter: this.props.customFilter,
    },
    showEmailReportConfirm: false,
    downloadReportModalShow: false,
    showShareModal: false,
    pendingProfile: { inputValue: false },
    inconsistentProfile: { inputValue: false },
    emotionalIntelligence: { inputValue: null },
    lastConsistentResults: false,
    invitation_selected: null,
    range: {
      start: this.props.customFilter?.start_range || this.props.start_date,
      end: this.props.customFilter?.end_range || this.props.end_date,
    },
    filterApplied: false,
    didFilter: false,
    clearInput: false,
    batchedReportsLoading: false,
    normalReportsLoading: false,
  };

  bulkReportsDispatchLock = false;

  componentDidMount() {
    this._isMounted = true;
    if (this.props.savedSearchInput) {
      this.props.saveSearchInput(false);
    }
    this.props.clearSelection();
    this.props.clearPersonCustomFilters();

    this.handleSubmit(false, true);

    this.props.getAllProfiles({});
    this.props.getCountries();
    if (!this.props.user.branch?.id)
      this.props.getAllClients(true, true, false);
    this.props.getAllCampaigns({
      partners: null,
      campaign_dropdown: true,
    });
    // Load initial institutions without search
    this.props.getInstitutions('');

    this.setState({
      ...this.state,
      filterApplied: false,
      range: {
        start:
          this.props.customFilter?.start_range ||
          this.state.start_date ||
          this.props.start_date,
        end:
          this.props.customFilter?.end_range ||
          this.state.end_date ||
          this.props.end_date,
      },
      clearInput: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.start_date !== this.props.start_date) {
      this.filterByDates({
        start_range: this.props.start_date,
        end_range: this.props.end_date,
      });
    }

    if (prevState.clearInput === true) {
      this.setState({
        ...this.state,
        clearInput: false,
      });
    }

    if (prevProps.selection.length && this.props.selection.length === 0) {
      this.props.clearSelection();
    }

    // Detectar cambios en el estado de reportes normales
    if (
      this.state.normalReportsLoading &&
      prevProps.reportsStatus.loading &&
      !this.props.reportsStatus.loading
    ) {
      if (this.normalDownloadTimeoutId) {
        clearTimeout(this.normalDownloadTimeoutId);
        this.normalDownloadTimeoutId = null;
      }
      this.setNormalReportsLoading(false);

      this.bulkReportsDispatchLock = false;
    }
  }

  getUniqueSelectedReports = () => {
    const { allSelected, selection, allResultsSelected } = this.props;
    const source = allSelected ? allResultsSelected : selection;
    const seen = new Set();

    return source.filter((item) => {
      const resultId = item?.id_result;
      const invitationId = item?.id_invitation;
      const dedupeKey = `${resultId || 'none'}-${invitationId || 'none'}`;

      if (seen.has(dedupeKey)) {
        return false;
      }

      seen.add(dedupeKey);
      return true;
    });
  };

  addOption = (type, name, option) => {
    let newArray = [...this.state.values[name].inputValue];
    let pendValue = this.state.pendingProfile.inputValue;
    let incValue = this.state.inconsistentProfile.inputValue;
    if (type === 'add' || type === true) {
      newArray = newArray.concat([option]);
    } else {
      newArray = newArray.filter((opt) => opt.code !== option.code);
    }
    if (option.description === 'Pendiente') {
      pendValue = type;
    }
    if (option.description === 'Inconsistente') {
      incValue = type;
    }
    if (name === 'partners') {
      this.props.getAllCampaigns(newArray.map(({ code }) => code));
    }
    newArray.sort((profile1, profile2) => {
      return profile2.code - profile1.code;
    });
    this.setState(
      {
        ...this.state,
        pendingProfile: { inputValue: pendValue },
        inconsistentProfile: { inputValue: incValue },
        values: {
          ...this.state.values,
          [name]: { ...this.state.values[name], inputValue: [...newArray] },
        },
        didFilter: true,
      },
      () => {
        this.handleSubmit();
      },
    );
  };

  addOptionIE = (type, name, option) => {
    let ieValue = type;
    let filtered = option?.length > 0 ? true : false;
    this.setState(
      {
        ...this.state,
        emotionalIntelligence: { inputValue: ieValue },
        values: {
          ...this.state.values,
          [name]: { ...this.state.values[name], inputValue: ieValue?.code },
        },
        filterApplied: filtered,
      },
      () => {
        this.handleSubmit();
      },
    );
  };

  onHide = () => {
    this.setState({
      ...this.state,
      showFilter: false,
      showEmailReportConfirm: false,
      showShareModal: false,
    });

    if (!this.state.filterApplied) {
      this.setState({
        ...this.state,
        showFilter: false,
        showEmailReportConfirm: false,
        showShareModal: false,
        //values: { ...this.state.values, ...initialValues },
      });
    }
  };

  modalShow = () => {
    if (this.state.downloadReportModalShow === false) {
      this.setState({
        ...this.state,
        showEmailReportConfirm: false,
        downloadReportModalShow: true,
      });
    } else {
      this.setState({
        ...this.state,
        downloadReportModalShow: false,
      });
    }
  };

  handleOnclick = (e) => {
    e.preventDefault();
    this.sendIeInvitation();
    this.ieResponse();
  };

  sendIeInvitation = () => {
    let persons = [];
    this.props.selection.length &&
      this.props.selection.map((person) => {
        persons.push({
          id_invitation: person.id_invitation,
          id_campaign: person.campaign.id,
          email: person.email,
        });
      });
    this.props.massiveIeInvitation(persons);
  };

  ieResponse = () => {
    const { error, success, loading } = this.props.massiveIeResponse;
    if (success) {
      notify.show(
        <SnackBar
          icon={'priority'}
          title={I18n.t('common.excellent')}
          body={I18n.t('campaigns.ie.massiveIe')}
          iconFilled
          type="success"
        />,
        'custom',
        5000,
        successMessage,
      );
    }
    this.props.clearSelection();
  };
  resetSelection = () => {
    this.setState({
      ...this.state,
      values: { ...this.state.values, ...initialValues },
      didFilter: false,
    });
  };

  /**
   * Helper method to determine if there are any active filters
   * This checks all filter values, date ranges, and search input
   * @returns {boolean} True if any filter is active
   */
  hasActiveFilters = () => {
    const {
      values,
      range,
      pendingProfile,
      inconsistentProfile,
      emotionalIntelligence,
    } = this.state;
    const { customFilter, start_date, end_date } = this.props;

    // Check if search has active value
    const hasSearchFilter =
      values.search?.inputValue?.length >= 3 ||
      customFilter?.search?.length >= 3;

    // Check if date range is different from default
    const hasDateFilter =
      (customFilter?.start_range && customFilter.start_range !== start_date) ||
      (customFilter?.end_range && customFilter.end_range !== end_date) ||
      (range?.start && range.start !== start_date) ||
      (range?.end && range.end !== end_date);

    // Check dropdown filters
    const hasProfileFilter = values.profiles?.inputValue?.length > 0;
    const hasCampaignFilter = values.campaigns?.inputValue?.length > 0;
    const hasAgeFilter = values.age?.inputValue && values.age.inputValue !== '';
    const hasGenderFilter = values.genders?.inputValue?.length > 0;
    const hasPartnerFilter = values.partners?.inputValue?.length > 0;
    const hasInstitutionFilter =
      values.institutionDropdown?.inputValue !== null;

    // Check special filters
    const hasPendingFilter = pendingProfile?.inputValue === true;
    const hasInconsistentFilter = inconsistentProfile?.inputValue === true;
    // IE filter: check if inputValue is a valid filter value
    // Valid values: boolean (true/false) or object with code property (from dropdown selection)
    // Invalid/cleared values: null, undefined, empty array [], or empty string
    const ieValue = emotionalIntelligence?.inputValue;
    const hasIEFilter =
      ieValue !== null &&
      ieValue !== undefined &&
      ieValue !== '' &&
      !(Array.isArray(ieValue) && ieValue.length === 0) &&
      (typeof ieValue === 'boolean' ||
        (typeof ieValue === 'object' && ieValue?.code !== undefined));

    return (
      hasSearchFilter ||
      hasDateFilter ||
      hasProfileFilter ||
      hasCampaignFilter ||
      hasAgeFilter ||
      hasGenderFilter ||
      hasPartnerFilter ||
      hasInstitutionFilter ||
      hasPendingFilter ||
      hasInconsistentFilter ||
      hasIEFilter
    );
  };

  setBatchedReportsLoading = (loading) => {
    if (this._isMounted !== false) {
      this.setState({ batchedReportsLoading: loading });
    }
  };

  setNormalReportsLoading = (loading) => {
    if (this._isMounted !== false) {
      this.setState({ normalReportsLoading: loading });
    }
  };

  downloadReport = (name, option) => {
    const { allSelected } = this.props;
    const uniqueSelectedReports = this.getUniqueSelectedReports();
    let reportFolder;

    const branchName = this.props.user.branch?.name || '';
    // Activar loader inmediatamente como respaldo
    const hasINESAccount = isINESAccount(this.props?.user?.account);
    const isINESType = isINESBranch(branchName);

    // NW-2367: INES (El Salvador) keeps the 25-person cap per download run
    if ((isINESType || hasINESAccount) && uniqueSelectedReports.length > 25) {
      notify.show(
        <SnackBar
          icon={'report'}
          title={I18n.t('common.attention')}
          body={I18n.t('persons.error.downloadLimit', { max: 25 })}
          type="error"
          iconFilled
        />,
        'custom',
        5000,
        errorMessage,
      );
      return;
    }

    if (isINESType || hasINESAccount) {
      this.setBatchedReportsLoading(true);
    } else {
      this.setNormalReportsLoading(true);
    }

    if (isINESBranch(branchName) || hasINESAccount) {
      // Helper function to get report type label
      const getReportTypeLabel = (code) => {
        switch (code) {
          case 'individual':
            return 'Individual';
          case 'empresa':
            return 'Empresa';
          default:
            return code;
        }
      };

      const downloadPromise = servicesReports.getBatchedReportsAndDownload(
        allSelected
          ? uniqueSelectedReports.map((r) => {
              return {
                playerId: r?.player_id,
                type: option.code,
                playerName: r?.full_name || `Player_${r?.player_id}`,
                reportTypeLabel: getReportTypeLabel(option.code),
              };
            })
          : uniqueSelectedReports.map((s) => {
              return {
                playerId: s?.player_id,
                type: option.code,
                playerName: s?.full_name || `Player_${s?.player_id}`,
                reportTypeLabel: getReportTypeLabel(option.code),
              };
            }),
        5, // Fixed batchSize - process in batches of 5 instead of all at once
        false,
        'pdf',
      );

      return downloadPromise
        .then((result) => {
          this.setBatchedReportsLoading(false);
          return result;
        })
        .catch((error) => {
          this.setBatchedReportsLoading(false);
        });
    }

    if (!this.props.user.user_admin) {
      const { branch, account } = this.props.user;
      reportFolder =
        account?.length > 0
          ? {
              individual_report_folder: account?.individual_report_folder,
              company_report_folder: account?.company_report_folder,
            }
          : {
              individual_report_folder: branch?.individual_report_folder,
              company_report_folder: branch?.company_report_folder,
            };
    } else {
      reportFolder = null;
    }

    this.props.downloadProfileReport(
      uniqueSelectedReports,
      option.code,
      reportFolder,
    );
  };

  handleInputChange = (key, value) => {
    // Si se selecciona una institución del dropdown
    if (key === 'institutionDropdown' && value && value.description) {
      this.setState(
        {
          values: {
            ...this.state.values,
            [key]: { ...this.state.values[key], inputValue: value },
            institution: { inputValue: value.description },
          },
          didFilter: true,
        },
        () => {
          // Actualizar filtros con el nombre de la institución seleccionada
          this.props.updateFilterValues({
            ...this.state,
            institution: value.description,
          });
          this.handleSubmit();
        },
      );
    } else {
      this.setState(
        {
          values: {
            ...this.state.values,
            [key]: { ...this.state.values[key], inputValue: value },
          },
          didFilter: true,
        },
        () => {
          this.handleSubmit();
        },
      );
    }
  };

  handleSearch = (key, value) => {
    let current = this.state.values.search.inputValue;
    this.setState(
      {
        values: {
          ...this.state.values,
          [key]: { ...this.state.values[key], inputValue: value },
        },
        didFilter: true,
      },
      () => {
        // Execute search if text is being reduced (deleting characters) or if length >= 3
        if (
          this.state.values.search.inputValue.length >= 3 ||
          current.length > this.state.values.search.inputValue.length
        ) {
          if (this.searchTimeout) clearTimeout(this.searchTimeout);

          this.searchTimeout = setTimeout(() => {
            this.handleSubmit();
          }, 300);
        }
      },
    );
  };

  handleFilterRemove() {
    this.props.clearFilter();
    this.props.saveSearchInput('');

    const hasINESAccount = isINESAccount(this.props?.user?.account);
    const isINESType = isINESBranch(this.props.user.branch?.name || '');

    let filterParams = {
      start_range: this.props.start_date,
      end_range: this.props.end_date,
      ordering: this.props.customFilter.ordering,
      search: '',
    };

    // Add branch parameter for INES requests
    const branchParam = getINESBranchParameter(this.props.user);
    if ((isINESType || hasINESAccount) && branchParam) {
      filterParams.branch = branchParam;
    }

    this.props.filterPersons(filterParams, true, isINESType || hasINESAccount);
    this.setState({
      ...this.state,
      pendingProfile: { inputValue: false },
      inconsistentProfile: { inputValue: false },
      emotionalIntelligence: { inputValue: null },
      filterApplied: false,
      range: {
        start: this.props.start_date,
        end: this.props.end_date,
      },
      values: { ...this.state.values, ...initialValues },
      didFilter: false,
      clearInput: true,
    });
  }

  handleSubmit = (
    lastConsistentResults = this.state.lastConsistentResults,
    resetPage = true,
  ) => {
    let submitForm = {
      ordering: this.props.customFilter.ordering,
      search: this.props.customFilter.search,
    };

    Object.keys(this.state.values).forEach((value) => {
      if (
        this.state.values[value].inputValue !== '' &&
        this.state.values[value].inputValue?.length !== 0
      ) {
        submitForm = {
          ...submitForm,
          [value]: Array.isArray(this.state.values[value].inputValue)
            ? this.state.values[value].inputValue.map((res) => res.code)
            : this.state.values[value].inputValue?.code
            ? this.state.values[value].inputValue.code
            : this.state.values[value].inputValue,
        };
      }
    });
    this.setState({
      ...this.state,
      filterApplied: Object.keys(submitForm).length > 2,
      showFilter: false,
      lastConsistentResults,
    });
    submitForm.branchs = submitForm.partners;

    // If institutionDropdown is selected, rename it to institutionId for API
    if (submitForm.institutionDropdown) {
      submitForm.institutionId = submitForm.institutionDropdown;
      delete submitForm.institutionDropdown;
    }

    const hasINESAccount = isINESAccount(this.props?.user?.account);
    const isINESType = isINESBranch(this.props.user.branch?.name || '');

    // Add branch parameter for INES requests
    const branchParam = getINESBranchParameter(this.props.user);
    if ((isINESType || hasINESAccount) && branchParam) {
      submitForm.branch = branchParam;
    }

    this.props.filterPersons(
      {
        ...submitForm,
        start_range: this.state.range.start,
        end_range: this.state.range.end,
        lastConsistentResults,
      },
      resetPage,
      isINESType || hasINESAccount,
    );
  };

  handleInstitutionSearch = (key, value) => {
    let current = this.state.values.institution.inputValue;
    this.setState(
      {
        ...this.state,
        values: {
          ...this.state.values,
          [key]: { ...this.state.values[key], inputValue: value },

          didFilter: true,
        },
      },
      () => {
        if (
          this.state.values.institution.inputValue.length >= 3 ||
          current.length > this.state.values.institution.inputValue.length
        ) {
          if (this.institutionSearchTimeout)
            clearTimeout(this.institutionSearchTimeout);

          this.institutionSearchTimeout = setTimeout(
            function () {
              this.props.updateFilterValues({
                ...this.state,
                institution: this.state.values.institution.inputValue,
              });
            }.bind(this),
            300,
          );
        }
      },
    );
  };

  handleInstitutionsDropdownSearch = (params) => {
    // FormDropdown passes { search: value } format
    const searchValue = params?.search || '';
    this.props.getInstitutions(searchValue);
  };

  handleCellEmailReportModal = (
    e,
    value,
    id_invitation,
    campaign,
    person_name,
  ) => {
    e.stopPropagation();

    this.setState({
      ...this.state,
      showEmailReportConfirm: true,
      emailReportSelected: {
        value,
        id_invitation,
        campaign,
        person_name,
      },
    });
  };

  handleCellEmailReportConfirm = () => {
    this.props.sendPersonReportEmail(this.state.emailReportSelected);
    notify.show(
      <SnackBar
        icon={'priority'}
        title={I18n.t('common.excellent')}
        body={
          I18n.t('persons.reportResended') +
          ' ' +
          this.state.emailReportSelected.person_name
        }
        iconFilled
        type="success"
      />,
      'custom',
      5000,
      successMessage,
    );
  };

  handleFiles = (files) => {
    this.props.migrateCampaign(files[0]);
  };

  selectAll = (flag) => {
    this.props.selectAll(flag);
    const allselectedInPage =
      this.props.filters.filter(
        (person) =>
          (person.conductual.result &&
            this.props.selection.find(
              (sel) => sel.id_invitation === person.conductual.id,
            )) ||
          !person.conductual.result,
      ).length === this.props.filters.length;
    if (flag && !allselectedInPage) {
      this.props.toggleSelectionAll();
    }
  };

  filterByDates = (filter) => {
    let submitForm = {
      ordering: this.props.customFilter.ordering,
      search: this.props.customFilter.search,
    };

    Object.keys(this.state.values).forEach((value) => {
      if (
        this.state.values[value].inputValue !== '' &&
        this.state.values[value].inputValue?.length !== 0
      ) {
        submitForm = {
          ...submitForm,
          [value]: Array.isArray(this.state.values[value].inputValue)
            ? this.state.values[value].inputValue?.map((res) => res.code)
            : this.state.values[value].inputValue?.code
            ? this.state.values[value].inputValue?.code
            : this.state.values[value].inputValue,
        };
      }
    });
    this.onHide();

    this.setState({
      ...this.state,
      range: { start: filter.start_range, end: filter.end_range },
    });
    const hasINESAccount = isINESAccount(this.props?.user?.account);
    const isINESType = isINESBranch(this.props.user.branch?.name || '');

    // Add branch parameter for INES requests
    const branchParam = getINESBranchParameter(this.props.user);
    if ((isINESType || hasINESAccount) && branchParam) {
      submitForm.branch = branchParam;
    }

    this.props.filterPersons(
      {
        ...submitForm,
        ...filter,
        lastConsistentResults: this.state.lastConsistentResults,
      },
      true,
      isINESType || hasINESAccount,
    );
  };

  handleActions = (name, option) => {
    if (option.code === 'tends') {
      this.props.history.push('/main/persons/group-trends');
      return;
    }

    if (option.code === 'individual' || option.code === 'empresa') {
      // Cerrar el modal antes de iniciar la descarga
      this.setState({
        ...this.state,
        downloadReportModalShow: false,
      });

      this.downloadReport(name, option);
      return;
    }

    if (option.code === 'reports-parallel') {
      if (this.bulkReportsDispatchLock) return;
      this.bulkReportsDispatchLock = true;

      const reportTypes = [...new Set(option.reportTypes || [])].filter(
        (type) => type === 'individual' || type === 'empresa',
      );
      if (!reportTypes.length) {
        this.bulkReportsDispatchLock = false;
        return;
      }

      const hasINESAccount = isINESAccount(this.props?.user?.account);
      const isINESType = isINESBranch(this.props.user.branch?.name || '');

      if (isINESType || hasINESAccount) {
        this.setState(
          {
            ...this.state,
            downloadReportModalShow: false,
          },
          () => {
            Promise.all(
              reportTypes.map((reportType) =>
                this.downloadReport(name, { code: reportType }),
              ),
            ).finally(() => {
              this.bulkReportsDispatchLock = false;
            });
          },
        );
        return;
      }

      this.setState(
        {
          ...this.state,
          downloadReportModalShow: false,
        },
        () => {
          reportTypes.forEach((reportType) => {
            this.downloadReport(name, { code: reportType });
          });
        },
      );

      return;
    }
  };

  toggleLastResultStatus = () => {
    let value = this.state.lastConsistentResults;
    this.handleSubmit(!value);
  };
  allSelectioninPage = () => {
    let flag = true;
    this.props.filters.map((person) => {
      const result = this.props.selection.find(
        (s) => s.id_invitation === person.conductual.id,
      );
      if (!result) {
        flag = false;
      }
    });
    return flag;
  };

  handleDisable() {
    const data = this.props.selection.find((a) => a?.profile?.id !== 27);
    if (data !== undefined) return false;
    return true;
  }

  /**
   * Determines if the IE invitation button should be disabled
   * Returns true (disabled) if:
   * - No candidates are selected with valid profiles (not inconsistent)
   * - All selected candidates are either inconsistent OR already have completed IE results
   */
  handleDisableIeInvitation() {
    // Selection is global; eligibility must not depend on currently visible filtered rows.
    const selectedEligibleForIe = this.props.selection.filter((selected) => {
      // If inconsistent, not eligible for IE invitation
      if (selected?.profile?.id === 27) return false;

      // If already has IE completed, not eligible for IE invitation
      if (selected?.ie?.type === 'IE' && selected?.ie?.status === 'COMPLETED') {
        return false;
      }

      // Eligible for IE invitation
      return true;
    });

    // If no selected candidates are eligible for IE invitation, disable the button
    if (selectedEligibleForIe.length === 0) return true;

    return false;
  }
  render() {
    this.checkNotificationRenders();
    const { loading, success, error } = this.props.retrieveStatus;
    const { loading: loadingReports } = this.props.reportsStatus;
    const { allSelected, allLoaded } = this.props;

    const actions = [
      { code: 'reports', label: I18n.t('persons.reports'), menu: true },
      {
        code: 'individual',
        label: I18n.t('persons.individualReport'),
        subitem: true,
        disabled:
          this.props.selection.length < 1 ||
          loading ||
          (allSelected && !allLoaded),
      },
      {
        code: 'empresa',
        label: I18n.t('persons.partnerReport'),
        subitem: true,
        disabled:
          this.props.selection.length < 1 ||
          loading ||
          (allSelected && !allLoaded),
      },
      {
        code: 'tends',
        label: I18n.t('persons.groupTendencies'),
        disabled:
          this.props.selection.length < 1 ||
          loading ||
          (allSelected && !allLoaded),
      },
    ];
    const { loading: loadingDates } = this.props.dateStatus;
    let allprofiles = [
      {
        id: -1,
        name: I18n.t('dashboard.profileFilterPlaceholder'),
        description: '',
        traits: Array(0),
      },
    ].concat(this.props.profiles);
    if (this.props.shareFileStatus.success) {
      notify.show(
        <SnackBar
          icon={'priority'}
          title={I18n.t('persons.excellent')}
          body={I18n.t('persons.shareSuccess')}
          type="success"
          iconFilled
        />,
        'custom',
        5000,
        successMessage,
      );
      this.props.clearUiValue('shareFileStatus', 'success');
    }
    return this.state.batchedReportsLoading ||
      this.state.normalReportsLoading ||
      loadingReports ? (
      <Loader />
    ) : (
      <>
        {this.state.downloadReportModalShow && (
          <DownloadReportModal
            show={this.state.downloadReportModalShow}
            action={this.handleActions}
            onHide={this.modalShow}
            isINESBranch={
              isINESBranch(this.props.user.branch?.name || '') ||
              isINESAccount(this.props?.user?.account)
            }
          />
        )}

        <ModalShare
          show={this.state.showShareModal}
          action={(body) =>
            this.props.shareFile({
              id_invitation: this.state.invitation_selected,
              ...body,
            })
          }
          onHide={this.onHide}
        />

        <div className="container-fluid persons-custom-container">
          <EmailReportConfirmModal
            show={this.state.showEmailReportConfirm}
            onHide={this.onHide}
            onConfirm={this.handleCellEmailReportConfirm}
            name={this.state.emailReportSelected?.person_name}
          />
          <Tabs
            defaultActiveKey={this.props.defaultTab || 1}
            id="uncontrolled-tab-example"
            onSelect={this.handleSelect}
            value={this.state.selectedTab}
          >
            <div className={'card-header-right'}>
              {(this.props.user.user_admin ||
                this.props.user.branch?.account.ie_active ||
                this.props.user.account?.ie_active) && (
                <Button
                  className="button-download-report"
                  text={I18n.t('campaigns.ie.inviteIe')}
                  disabled={this.handleDisableIeInvitation()}
                  iconButton={false}
                  onClick={this.handleOnclick}
                />
              )}
              <Button
                className="button-download-report"
                text={I18n.t('persons.downloadReport')}
                disabled={this.handleDisable()}
                iconClass="download"
                iconButton
                onClick={this.modalShow}
              />
              <Button
                className="primary"
                disabled={this.handleDisable()}
                text={I18n.t('common.sidebar.compatibility')}
                iconClass="swap_horiz"
                iconButton
                onClick={() => {
                  persistGroupTrendsSelection(this.props.selection);
                  window.location.assign(
                    '/main/persons/group-trends?selected-items=true',
                  );
                }}
              />
            </div>
            <Tab eventKey={1} title={I18n.t('common.sidebar.persons')}>
              {allSelected && !allLoaded ? (
                <Loader />
              ) : (
                <>
                  <div className="filters">{this.renderFilters()}</div>
                  {this.renderTable()}
                </>
              )}
            </Tab>
          </Tabs>
        </div>
      </>
    );
  }

  renderFilters() {
    let allprofiles = [
      {
        id: -1,
        name: I18n.t('dashboard.profileFilterPlaceholder'),
        description: '',
        traits: Array(0),
      },
    ].concat(this.props.profiles);
    let profileValues = {
      inputValue: this.state.values.profiles.inputValue.filter(
        (f) => f.code !== 28 && f.code !== 27,
      ),
    };
    return (
      <div className="filters-container">
        <SearchInput
          value={this.state.values.search.inputValue}
          name="search"
          placeholder={I18n.t('persons.search')}
          onChange={(e) => this.handleSearch('search', e.target.value)}
          displayValue={this.state.values.search.inputValue}
        />

        {/* Institution search - only for El Salvador dashboards */}
        {(isINESBranch(this.props.user.branch?.name || '') ||
          isINESAccount(this.props?.user?.account)) && (
          <FormDropdown
            name={'institutionDropdown'}
            value={this.state.values.institutionDropdown}
            options={this.props.institutions.map((institution) => ({
              code: institution.id,
              description: institution.name,
            }))}
            placeholder={I18n.t('persons.searchInstitution')}
            search={this.handleInstitutionsDropdownSearch}
            loading={this.props.institutionsStatus.loading}
            showEmptyOption
            change={this.handleInputChange}
            cleanOption={true}
            clearInput={this.state.clearInput}
            cleanSelected={() =>
              this.setState(
                {
                  ...this.state,
                  values: {
                    ...this.state.values,
                    institutionDropdown: { inputValue: null },
                    institution: { inputValue: '' },
                  },
                  didFilter: true,
                },
                () => this.handleSubmit(),
              )
            }
            dropDownClean={() =>
              this.setState(
                {
                  ...this.state,
                  values: {
                    ...this.state.values,
                    institutionDropdown: { inputValue: null },
                    institution: { inputValue: '' },
                  },
                  didFilter: true,
                },
                () => this.handleSubmit(),
              )
            }
          />
        )}

        <DateRangePickerFilter
          hiddenPopup={true}
          popupUp={true}
          rangeDefault={{
            start: this.props.customFilter.start_range || this.props.start_date,
            end: this.props.customFilter.end_range || this.props.end_date,
          }}
          previewRange={{
            start: this.state.range.start,
            end: this.state.range.end,
          }}
          start_date={this.state.range.start}
          end_date={this.state.range.end}
          didFilter={this.state.didFilter}
          key={
            this.state.range.start +
            this.props.customFilter.start_range +
            this.props.customFilter.end_range +
            this.state.range.end +
            this.props.start_date +
            this.props.end_date
          }
          classNameButton="date-person"
          {...this.props}
          filter={(e) => {
            this.setState({ ...this.state, didFilter: true }, () => {
              this.filterByDates(e);
            });
          }}
        />

        <FormDropdown
          value={this.state.values.age}
          name={'age'}
          loading={false}
          options={[
            { code: '0-19', description: '<19' },
            { code: '20-29', description: '20 - 29' },
            { code: '30-39', description: '30 - 39' },
            { code: '40-49', description: '40 - 49' },
            { code: '50-59', description: '50 - 59' },
            { code: '60-100', description: '>60' },
          ]}
          placeholder={I18n.t('persons.age')}
          change={this.handleInputChange}
          title={I18n.t('persons.ageRange')}
          cleanOption={true}
          className="age"
          cleanSelected={() =>
            this.setState(
              {
                ...this.state,
                values: { ...this.state.values, age: { inputValue: '' } },
              },
              () => this.handleSubmit(),
            )
          }
        />

        <FormDropdown
          placeholder={I18n.t('persons.profile')}
          multiSelect
          search={this.props.getAllProfiles}
          loading={false}
          showEmptyOption
          getAllClientsPrompts={{ search: '' }}
          name={'profiles'}
          value={profileValues}
          addOption={this.addOption}
          clearInput={this.state.clearInput}
          options={allprofiles
            ?.filter((fil) => fil.id !== 27 && fil.id !== 28)
            .map((profile) => ({
              code: profile.id,
              description: profile.name,
            }))}
          cleanOption={true}
          cleanSelected={() =>
            this.setState(
              {
                ...this.state,
                values: { ...this.state.values, profiles: { inputValue: [] } },
              },
              () => this.addOption(null, 'profiles', ''),
            )
          }
        />
        <FormDropdown
          name={'campaigns'}
          multiSelect
          addOption={this.addOption}
          value={this.state.values.campaigns}
          options={this.props.allCampaigns.map((campaign) => ({
            code: campaign.id,
            description: campaign.name,
          }))}
          placeholder={I18n.t('campaigns.identifierAlternative')}
          search={this.props.getAllCampaigns}
          loading={false}
          showEmptyOption
          change={this.handleInputChange}
          getAllClientsPrompts={{
            partners: null,
            campaign_dropdown: true,
          }}
          cleanOption={true}
          clearInput={this.state.clearInput}
          cleanSelected={() =>
            this.setState(
              {
                ...this.state,
                values: { ...this.state.values, campaigns: { inputValue: [] } },
              },
              () => this.addOption(null, 'campaigns', ''),
            )
          }
        />

        {(this.props.user.branch?.account?.ie_active === true ||
          this.props.user.account?.ie_active === true ||
          this.props.user.user_admin) && (
          <>
            {/* <SquareButton
              label={I18n.t('persons.IE.filter')}
              className="emotional-intelligence-check"
              name={'emotionalIntelligence'}
              value={this.state.emotionalIntelligence}
              setValue={!this.state.emotionalIntelligence.inputValue}
              change={(name, setValue, data) => {
                this.addOptionIE(setValue, name, data);
              }}
              data={{ code: 0, description: 'emotionalIntelligence' }}
            /> */}
            <FormDropdown
              value={this.state.emotionalIntelligence}
              name={'emotionalIntelligence'}
              loading={false}
              options={[
                { code: true, description: I18n.t('common.yes') },
                { code: false, description: I18n.t('common.no') },
              ]}
              placeholder={I18n.t('persons.IE.filter')}
              change={(name, setValue, data) => {
                this.addOptionIE(setValue, name, data);
              }}
              title={null}
              cleanOption={true}
              cleanSelected={() =>
                this.setState(
                  {
                    ...this.state,
                    emotionalIntelligence: { inputValue: null },
                    values: {
                      ...this.state.values,
                      emotionalIntelligence: { inputValue: [] },
                    },
                  },
                  () => this.handleSubmit(),
                )
              }
              className="age"
            />
          </>
        )}
        <SquareButton
          label={I18n.t('persons.inconsistent')}
          className="inconsistent-profile-check"
          name={'profiles'}
          value={this.state.inconsistentProfile}
          setValue={!this.state.inconsistentProfile.inputValue}
          change={(name, setValue, data) => {
            this.addOption(setValue, name, data);
          }}
          data={{ code: 27, description: 'Inconsistente' }}
        />

        {this.hasActiveFilters() && (
          <div className="delete-button-container">
            <Button
              className="text-link-button delete-button"
              text={I18n.t('buttons.clearFilter')}
              onClick={() => this.handleFilterRemove()}
              iconButton={true}
              iconClass={'close'}
            />
          </div>
        )}
      </div>
    );
  }
  renderTable() {
    const { loading, success, error } = this.props.retrieveStatus;
    const { loading: loadingCampaigns } = this.props.allCampaignsStatus;
    const { loading: loadingFilter } = this.props.retrieveFilter;
    const { customFilter, totalCount, allSelected, results } = this.props;
    const orderingFilterObj = {
      desc: customFilter.ordering[0] === '-',
      id:
        customFilter.ordering[0] === '-'
          ? customFilter.ordering.slice(1, customFilter.ordering.length)
          : customFilter.ordering,
    };
    const pageSelection = this.props.selection.length;
    let extraColumns = [];
    let emailColumn = [];
    let ieColumn = [];
    if (
      (this.props.user.account &&
        this.props.user.account?.campaign_field !== null) ||
      (this.props.user.branch &&
        this.props.user.branch?.account?.campaign_field !== null)
    ) {
      let fields =
        this.props.user.account?.campaign_field?.fieldsName ||
        this.props.user.branch.account?.campaign_field?.fieldsName;
      fields?.map((field) =>
        extraColumns.push({
          Header: (
            <p className="header-table">
              <span>{I18n.t('persons.EAE.' + field)}</span>
            </p>
          ),
          headerClassName: 'wordwrap campaign-table',
          className: 'campaign-table',
          id: field,
          accessor: `user_player.info.${field}`,
          Cell: (props) => {
            if (field === 'date') {
              let date;
              if (props.value && dayjs(props.value, 'DD/MM/YYYY').isValid()) {
                date = new Date(props.value.split('/').reverse().join('/'));
              } else {
                date = props.value;
              }

              return (
                <>
                  <span
                    className="large-text"
                    id={'optional-' + field + props.original.id}
                    data-tooltip-id={'tooltip-' + field + props.original.id}
                    data-tooltip-content={
                      props.value && dayjs(props.value, 'DD/MM/YYYY').isValid()
                        ? `${date
                            .toLocaleDateString(this.props.language, {
                              month: 'long',
                            })
                            .replace(/^\w/, (c) =>
                              c.toUpperCase(),
                            )} ${date.toLocaleDateString(this.props.language, {
                            year: 'numeric',
                          })}`
                        : props.value
                        ? date
                        : I18n.t('persons.notRequested')
                    }
                  >
                    {props.value && dayjs(props.value, 'DD/MM/YYYY').isValid()
                      ? `${date
                          .toLocaleDateString(this.props.language, {
                            month: 'long',
                          })
                          .replace(/^\w/, (c) =>
                            c.toUpperCase(),
                          )} ${date.toLocaleDateString(this.props.language, {
                          year: 'numeric',
                        })}`
                      : props.value
                      ? date
                      : I18n.t('persons.notRequested')}
                  </span>
                  <LargeTextTooltip
                    id={'tooltip-' + field + props.original.id}
                    idToOverflow={'optional-' + field + props.original.id}
                  />
                </>
              );
            } else {
              return (
                <>
                  <span
                    className="large-text"
                    id={'optional-' + field + props.original.id}
                    data-tooltip-id={'tooltip-' + field + props.original.id}
                    data-tooltip-content={
                      props.value
                        ? field === 'language'
                          ? I18n.t('persons.EAE.' + props.value.toLowerCase())
                          : props.value
                        : I18n.t('persons.notRequested')
                    }
                  >
                    {props.value
                      ? field === 'language'
                        ? I18n.t('persons.EAE.' + props.value.toLowerCase())
                        : props.value
                      : I18n.t('persons.notRequested')}
                  </span>
                  <LargeTextTooltip
                    id={'tooltip-' + field + props.original.id}
                    idToOverflow={'optional-' + field + props.original.id}
                  />
                </>
              );
            }
          },
        }),
      );
    } else {
      emailColumn.push({
        Header: (
          <p className="header-table">
            <span>{I18n.t('persons.emailAddress')}</span>
            {this.props.customFilter.ordering === 'user__email' ? (
              <span class="material-symbols-rounded">arrow_drop_down</span>
            ) : this.props.customFilter.ordering === '-user__email' ? (
              <span class="material-symbols-rounded">arrow_drop_up</span>
            ) : (
              <span class="material-symbols-rounded">arrow_drop_down</span>
            )}
          </p>
        ),
        headerClassName: 'wordwrap email-table',
        className: 'email-table',
        id: 'user__email',
        accessor: (d) => ({
          email: d?.conductual?.email || '',
          id: d?.conductual?.id,
        }),
        Cell: (props) => (
          <>
            <span
              className="number"
              id={`email-person-${props.value.id}`}
              data-tooltip-id={`email-person-tooltip-${props.value.id}`}
              data-tooltip-content={props.value.email}
            >
              {props.value.email}
            </span>
            <LargeTextTooltip
              id={`email-person-tooltip-${props.value.id}`}
              idToOverflow={`email-person-${props.value.id}`}
            />
          </>
        ),
      });
      if (this.props.user.user_admin) {
        emailColumn.push({
          Header: (
            <p className="header-table">
              <span>{I18n.t('common.sidebar.filiales')}</span>
              {this.props.customFilter.ordering === 'branch' ? (
                <span class="material-symbols-rounded">arrow_drop_down</span>
              ) : this.props.customFilter.ordering === '-branch' ? (
                <span class="material-symbols-rounded">arrow_drop_up</span>
              ) : (
                <span class="material-symbols-rounded">arrow_drop_down</span>
              )}
            </p>
          ),

          id: 'branch',
          headerClassName: 'wordwrap campaign-table',
          className: 'campaign-table',
          accessor: (d) => ({
            name: d?.branch?.name,
            id: d?.conductual?.id,
          }),
          sortable: true,
          Cell: (props) => (
            <>
              <span
                id={`branch-person-${props.value.id}`}
                data-tooltip-id={`branch-person-tooltip-${props.value.id}`}
                data-tooltip-content={props.value.name || '-'}
              >
                {props.value.name || '-'}
              </span>
              <LargeTextTooltip
                id={`branch-person-tooltip-${props.value.id}`}
                idToOverflow={`branch-person-${props.value.id}`}
              />
            </>
          ),
        });
      }
    }

    if (
      this.props.user.branch?.account?.ie_active === true ||
      this.props.user.account?.ie_active === true ||
      this.props.user.user_admin
    ) {
      ieColumn.push({
        Header: (
          <p className="header-table">
            {/* <span>{I18n.t('persons.profile')}</span> */}
            <span
              data-tooltip-id="headerIETooltip"
              data-tooltip-content={I18n.t('persons.IE.filter')}
            >
              {I18n.t('common.ie')}
            </span>
            <Tooltip id="headerIETooltip" place="right" />
            {this.props.customFilter.ordering === 'emotional_intelligence' ? (
              <span class="material-symbols-rounded">arrow_drop_down</span>
            ) : this.props.customFilter.ordering ===
              '-emotional_intelligence' ? (
              <span class="material-symbols-rounded">arrow_drop_up</span>
            ) : (
              <span class="material-symbols-rounded">arrow_drop_down</span>
            )}
          </p>
        ),
        headerClassName: 'wordwrap',
        className: 'person-profile',
        id: 'emotional_intelligence',
        accessor: 'ie',
        Cell: (props) => {
          return (
            <span className="number">
              {props.value?.type === 'IE' && props.value?.status === 'COMPLETED'
                ? I18n.t('common.yes').toUpperCase()
                : I18n.t('common.no').toUpperCase()}
            </span>
          );
        },
      });
    }
    if (error)
      return <div className="text-warning">{I18n.t('persons.error.list')}</div>;
    if (success || loading)
      return (
        <div className="table">
          <ReactTable
            columns={[
              {
                Header: (
                  <SquareButton
                    value={{
                      inputValue: this.allSelectioninPage(),
                    }}
                    disabled={results.length === 0}
                    change={this.props.toggleSelectionAll}
                  />
                ),
                id: 'result',
                headerClassName: 'checkbox-header',
                className: 'checkbox-column',
                accessor: (d) => {
                  return {
                    id_result: d.conductual?.result?.id,
                    id_invitation: d.conductual?.id,
                    campaign: d.campaign,
                    profile: d.profile,
                    ie: d.ie,
                    email: d.conductual?.email,
                    full_name: d.user?.full_name,
                    user_id: d.user?.id,
                    player_id: d.user_player?.id,
                  };
                },
                width: 50,
                sortable: false,
                Cell: (props) => {
                  return (
                    <SquareButton
                      value={{
                        inputValue: this.props.selection.some(
                          (sel) =>
                            props.value.id_invitation &&
                            sel.id_invitation === props.value.id_invitation,
                        ),
                      }}
                      disabled={!props.value}
                      change={() =>
                        this.props.addRemovePersonToSelection(props.value)
                      }
                    />
                  );
                },
                getProps: () => ({
                  onClick: (e) => e.stopPropagation(),
                  style: { cursor: 'default' },
                }),
              },
              {
                Header: (
                  <p className="header-table">
                    <span>{I18n.t('persons.first_name')}</span>
                    {this.props.customFilter.ordering === 'user__first_name' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    ) : this.props.customFilter.ordering ===
                      '-user__first_name' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_up
                      </span>
                    ) : (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    )}
                  </p>
                ),
                headerClassName: 'wordwrap',
                className: 'resultt',
                id: 'user__first_name',
                accessor: (d) => ({
                  full_name: d.user?.full_name,
                  code: d.conductual?.code,
                }),
                Cell: (props) => (
                  <div className="full-name">
                    <span
                      id={`full-name-person-${props.original.conductual?.id}`}
                      data-tooltip-id={`full-name-person-tooltip-${props.original.conductual?.id}`}
                      data-tooltip-content={props.value.full_name}
                    >
                      {props.value.full_name}
                    </span>
                    <LargeTextTooltip
                      id={`full-name-person-tooltip-${props.original.conductual?.id}`}
                      idToOverflow={`full-name-person-${props.original.conductual?.id}`}
                    />
                    <span className="code">
                      {props.value.code?.length === 12
                        ? `${props.value.code.substring(
                            0,
                            4,
                          )}-${props.value.code.substring(
                            4,
                            8,
                          )}-${props.value.code.substring(8, 12)}`
                        : props.value.code?.length === 9
                        ? `${props.value.code.substring(
                            0,
                            3,
                          )}-${props.value.code.substring(
                            3,
                            6,
                          )}-${props.value.code.substring(6, 9)}`
                        : '-'}
                    </span>
                  </div>
                ),
              },
              {
                Header: (
                  <p className="header-table">
                    <span>{I18n.t('persons.profile')}</span>
                    {this.props.customFilter.ordering === 'profile_name' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    ) : this.props.customFilter.ordering === '-profile_name' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_up
                      </span>
                    ) : (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    )}
                  </p>
                ),
                headerClassName: 'wordwrap',
                className: 'person-profile',
                id: 'profile_name',
                accessor: (d) => ({
                  name: d.profile?.[`name_${this.props.language}`],
                  id: d.conductual?.id,
                }),
                Cell: (props) => {
                  return (
                    <div className="profile-name-container">
                      <span
                        id={`profile-person-${props.value.id}`}
                        data-tooltip-id={`profile-person-tooltip-${props.value.id}`}
                        data-tooltip-content={props.value.name}
                        className="number"
                      >
                        {props.value.name}
                      </span>
                      <LargeTextTooltip
                        id={`profile-person-tooltip-${props.value.id}`}
                        idToOverflow={`profile-person-${props.value.id}`}
                      />
                    </div>
                  );
                },
              },
              ...ieColumn,
              {
                Header: (
                  <p className="header-table game_date">
                    <span>{I18n.t('persons.date')}</span>
                    {this.props.customFilter.ordering === 'game_date' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    ) : this.props.customFilter.ordering === '-game_date' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_up
                      </span>
                    ) : (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    )}
                  </p>
                ),
                headerClassName: 'wordwrap game-date-table',
                className: 'game-date-table',
                id: 'game_date',
                accessor: 'conductual.conversion_date',
                Cell: (props) => (
                  <span className="number">
                    {props.value
                      ? dayjs(props.value.substring(0, 10)).format('DD/MM/YYYY')
                      : ''}
                  </span>
                ),
              },
              ...emailColumn,
              {
                Header: (
                  <p className="header-table">
                    <span>{I18n.t('campaigns.identifier')}</span>
                    {this.props.customFilter.ordering === 'campaign_name' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    ) : this.props.customFilter.ordering ===
                      '-campaign_name' ? (
                      <span class="material-symbols-rounded">
                        arrow_drop_up
                      </span>
                    ) : (
                      <span class="material-symbols-rounded">
                        arrow_drop_down
                      </span>
                    )}
                  </p>
                ),
                headerClassName: 'wordwrap campaign-table',
                className: 'campaign-table',
                id: 'campaign_name',
                accessor: (d) => ({
                  name: d.campaign?.name,
                  id: d.conductual?.id,
                }),
                Cell: (props) => (
                  <>
                    <span
                      className="number"
                      id={`campaign-name-${props.value.id}`}
                      data-tooltip-id={`campaign-name-tooltip-${props.value.id}`}
                      data-tooltip-content={props.value.name || '-'}
                    >
                      {props.value.name ? props.value.name : '-'}
                    </span>
                    <LargeTextTooltip
                      id={`campaign-name-tooltip-${props.value.id}`}
                      idToOverflow={`campaign-name-${props.value.id}`}
                    />
                  </>
                ),
              },
              ...extraColumns,
              {
                //Header: I18n.t('persons.actions'),
                id: 'download-report',
                sortable: false,
                accessor: (d) => d.id,
                className: 'actions-table',
                width: 97,
                Cell: (props) => {
                  return (
                    <TableMenuItem>
                      <Dropdown
                        value={{
                          inputValue: {
                            code: '1',
                            label: (
                              <span class="material-symbols-rounded">
                                more_vert
                              </span>
                            ),
                          },
                        }}
                        className="users-dropdown"
                        noBorder
                        options={[
                          {
                            code: 'sendReport',
                            label: (
                              <p
                                onClick={(e) => {
                                  const branchName =
                                    props?.original?.branch?.name;
                                  const playerId =
                                    props?.original?.user_player?.id;
                                  if (
                                    isINESBranch(branchName) ||
                                    isINESAccount(this.props.user.account?.name)
                                  ) {
                                    servicesReports.resendPlayerReport(
                                      playerId,
                                    );
                                    return;
                                  }

                                  this.handleCellEmailReportModal(
                                    e,
                                    props.original.conductual?.result?.id,
                                    props.original.conductual?.id,
                                    props.original.campaign?.name,
                                    props.original.user?.full_name,
                                  );
                                }}
                              >
                                <span class="material-symbols-filled">
                                  assignment
                                </span>
                                <span>{I18n.t('persons.resendReport')}</span>
                              </p>
                            ),
                            disabled: false,
                          },
                          {
                            code: 'delete',
                            label: (
                              <p
                                onClick={(e) =>
                                  this.setState({
                                    ...this.state,
                                    showShareModal: true,
                                    invitation_selected:
                                      props.original.conductual?.id,
                                  })
                                }
                              >
                                <span class="material-symbols-filled">
                                  share
                                </span>
                                <span>{I18n.t('campaigns.share')}</span>
                              </p>
                            ),
                            disabled: false,
                          },
                        ]}
                      />
                    </TableMenuItem>
                  );
                },
                getProps: () => ({
                  onClick: (e) => e.stopPropagation(),
                  style: { cursor: 'default' },
                }),
              },
            ]}
            data={this.props.filters}
            minRows={0}
            minWith={5}
            resizable={false}
            noDataText={
              this.state.didFilter &&
              !this.state?.values?.institutionDropdown?.inputValue
                ? I18n.t('persons.table.noRows')
                : Boolean(
                    isINESBranch(this.props.user.branch?.name) ||
                      isINESAccount(this.props.user.account),
                  ) && this.state?.values?.institutionDropdown?.inputValue
                ? I18n.t('persons.table.noEntryINES')
                : I18n.t('persons.table.noEntry')
            }
            // TODO: ReactTable sorting
            defaultSorted={[
              {
                id: 'game_date',
                desc: false,
              },
            ]}
            sorted={[
              {
                id: orderingFilterObj.id,
                desc: orderingFilterObj.desc,
              },
            ]}
            onSortedChange={(newSorted, column, shiftKey) => {
              let columnId = column.id;
              let fields =
                this.props.user.account?.campaign_field?.fieldsName ||
                this.props.user.branch?.account?.campaign_field?.fieldsName;
              if (!fields || !fields.includes(columnId))
                this.props.updateFilterValues({
                  ordering: (newSorted[0].desc ? '-' : '') + columnId,
                  start_range: this.state.range.start,
                  end_range: this.state.range.end,
                });
            }}
            getTrProps={(state, rowInfo, column, instance) => {
              let className = '';
              this.props.selection.some((sel) => {
                if (sel.id_invitation === rowInfo.original.conductual.id) {
                  className = 'selected-row';
                }
              });
              return {
                onClick: (e, handleOriginal) => {
                  if (handleOriginal) {
                    handleOriginal();
                  }
                  this.props.selectPerson(rowInfo.original.conductual.code);
                  // this.props.history.push('/main/person');
                },
                style: {
                  cursor: 'pointer',
                },
                className,
              };
            }}
            manual // prop that tells ReactTable to dont client-side sort or paginate
            pageSize={this.props.pageSize}
            PaginationComponent={() => {
              const {
                currentPage,
                updatePage,
                totalPages,
                pageSize,
                totalCount,
                updatePageSize,
              } = this.props;
              const isOnFirstPage = currentPage === 1;
              const isOnLastPage = currentPage === totalPages;
              return (
                <TablePaginationDrawer
                  data={{
                    totalCount,
                    currentPage,
                    pageSize,
                    isOnFirstPage,
                    isOnLastPage,
                    updatePage,
                    updatePageSize,
                    totalPages,
                  }}
                  extraComponent={
                    <div className="multi-select">
                      {(allSelected ||
                        this.props.selection.length === totalCount) &&
                      totalCount > 1 ? (
                        <a
                          onClick={() => this.selectAll(false)}
                          href="#/"
                          className="total-select"
                        >
                          {' '}
                          {I18n.t('persons.clearSelect', { total: totalCount })}
                        </a>
                      ) : (
                        pageSelection > 0 &&
                        this.props.selection.length < totalCount && (
                          <div>
                            <span className="selected">
                              {I18n.t('persons.multiSelect', {
                                selected: this.props.selection.length, //pageSelection,
                                total: totalCount,
                              })}
                            </span>
                            {this.props.user.user_admin ? null : (
                              <a
                                onClick={() => this.selectAll(true)}
                                href="#/"
                                className="total-select"
                              >
                                {' '}
                                {I18n.t('persons.totalSelect')}
                              </a>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  }
                  table={'persons'}
                />
              );
            }}
            loading={loadingFilter || loadingCampaigns}
            LoadingComponent={TableLoader}
          />
        </div>
      );

    return <Loader />;
  }

  renderLastConsistentFilter() {
    return (
      <div className="filter-container">
        <Button
          className={
            this.state.lastConsistentResults ? 'primary applied' : 'primary'
          }
          text={I18n.t('persons.profileFilterButton')}
          onClick={this.toggleLastResultStatus}
        />
      </div>
    );
  }

  checkNotificationRenders() {
    if (
      this.props.updateStatus.success &&
      this.props.updateUserStatus.success
    ) {
      notify.show(I18n.t('persons.success.update'), 'custom', 5000, successUI);
      this.props.clearUiValue('update', 'success');
      this.props.clearUiValue('userUpdate', 'success');
    }
    if (this.props.deleteStatus.success) {
      notify.show(I18n.t('persons.success.delete'), 'custom', 5000, successUI);
      this.props.clearUiValue('delete', 'success');
    }
    if (this.props.deleteStatus.error) {
      notify.show(I18n.t('persons.error.delete'), 'custom', 5000, errorUI);
      this.props.clearUiValue('delete', 'error');
    }
    if (this.props.sendPersonReportEmailStatus.success) {
      notify.show(
        I18n.t('persons.success.sendReport'),
        'custom',
        5000,
        successUI,
      );
      this.props.clearUiValue('sendPersonReportEmailStatus', 'success');
    }
    if (this.props.sendPersonReportEmailStatus.error) {
      notify.show(I18n.t('persons.error.sendReport'), 'custom', 5000, errorUI);
      this.props.clearUiValue('sendPersonReportEmailStatus', 'error');
    }
  }

  componentWillUnmount() {
    this._isMounted = false;

    // Limpiar cualquier timeout de seguridad que pueda estar activo
    if (this.batchDownloadTimeoutId) {
      clearTimeout(this.batchDownloadTimeoutId);
    }
    if (this.normalDownloadTimeoutId) {
      clearTimeout(this.normalDownloadTimeoutId);
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    if (this.institutionSearchTimeout) {
      clearTimeout(this.institutionSearchTimeout);
    }

    const nextLocation = this.props.history.location.pathname;
    if (
      nextLocation !== '/main/person' &&
      nextLocation !== '/main/persons/group-trends' &&
      nextLocation !== '/'
    ) {
      // this.props.saveSearchInput({ inputValue: '' });
      // this.props.updateFilterValues({ search: '', page: 1, ordering: '-game_date'});
      this.props.clearSelection();
    }
    if (
      nextLocation === '/main/persons/group-trends' ||
      nextLocation === '/main/person'
    ) {
      this.props.saveSearchInput(this.state.values.search);
    }
  }
}

export default PersonsScreen;
